import axios from 'axios';
import { Navigate } from 'react-router-dom';
import AuthService from '../../Admin/services/AuthService';

const API_URL = process.env.REACT_APP_API_URL;

const FBIntegrationService = {
  getAllFBIntegrations: async () => {
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetAllFacebookClientConfigs`);
      return response.data.$values;
    } catch (error) { 
      console.error('Error fetching FBIntegartions:', error);
      throw error;
    }
  },

  getFBIntegrationById: async (id) => { 
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetFacebookClientConfigById/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching FBIntegartions with ID ${id}:`, error);
      throw error;
    } 
  },


  createFbIntegration: async (fbintegrationdata) => {
    debugger
    try {
      const response = await axios.post(`${API_URL}/FacebookClientConfig/CreateFacebookClientConfig/`, fbintegrationdata);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateFBIntegration: async (id, fbintegrationdata) => {
    try {
      const response = await axios.put(`${API_URL}/FacebookClientConfig/UpdateFacebookClientConfig/${id}`, fbintegrationdata);
      return response.data;
    } catch (error) {
      console.error(`Error updating FBIntegartion with ID ${id}:`, error);
      throw error;
    }
  }, 

  deleteFBIntegration: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/FacebookClientConfig/DeleteFacebookClientConfig/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting FBIntegartion with ID ${id}:`, error); 
      throw error;
    }
  },
  getFBIntegrationsByClientId: async (clientId) => {
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetFacebookClientConfigByClientId/${clientId}`);
      return response.data.$values;
    } catch (error) {
      console.error(`Error fetching FBIntegartion with ID ${clientId}:`, error);
      throw error;
    }
  }, 

  getFBIntegrationsAsyncByClientId: async (clientId) => {
    try {
      const response = await axios.get(`${API_URL}/FacebookClientConfig/GetFacebookClientConfigAsyncByClientId/${clientId}`);
      return response.data.$values;
    } catch (error) {
      console.error(`Error fetching FBIntegartion with ID ${clientId}:`, error);
      throw error;
    }
  }, 
};


export default FBIntegrationService;
